/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const CHANGE_SIDEBAR_VISIBILITY = 'CHANGE_SIDEBAR_VISIBILITY';
export const CHANGE_MOBILE_SIDEBAR_VISIBILITY = 'CHANGE_MOBILE_SIDEBAR_VISIBILITY';
export const SET_LOADING = 'SET_LOADING';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_BACKDROP = 'SET_BACKDROP';
export const SET_ACTUAL_CONTRACT = 'SET_ACTUAL_CONTRACT';
